/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import ErrorFallback from 'components/errorFallback'
import type { ErrorInfo, ReactNode, JSX } from 'react'
import { Component, createContext } from 'react'

export interface ErrorBoundaryState {
	error: Error | null
	retryCount: number
}

export interface ErrorFallbackProperties {
	error: Error
	onReset: () => void
}

export const ErrorBoundaryContext =
	createContext<ErrorFallbackProperties | null>(null)

export interface ErrorBoundaryProperties {
	children?: ReactNode
	onError?: (error: Error, info: ErrorInfo) => void
	onReset?: () => void
}

const initialState = { error: null, retryCount: 0 }
const MAX_TRIES = 3

export class ErrorBoundary extends Component<
	ErrorBoundaryProperties,
	ErrorBoundaryState
> {
	constructor(properties: ErrorBoundaryProperties) {
		super(properties)

		this.onReset = this.onReset.bind(this)

		this.state = initialState
	}

	static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
		// Ignore deployment-related errors - let AppReload handle them
		const errorMessage = error?.message || ''
		if (
			errorMessage.includes('Failed to fetch dynamically imported module') ||
			errorMessage.includes('ChunkLoadError') ||
			errorMessage.includes('Loading chunk') ||
			errorMessage.includes('preload') ||
			errorMessage.includes('vite')
		) {
			console.log(
				'Deployment error detected, ignoring in ErrorBoundary:',
				errorMessage
			)
			return { error: null }
		}
		return { error }
	}

	componentDidCatch(error: Error, info: ErrorInfo): void {
		// Also check in componentDidCatch to prevent logging deployment errors
		const errorMessage = error?.message || ''
		if (
			errorMessage.includes('Failed to fetch dynamically imported module') ||
			errorMessage.includes('ChunkLoadError') ||
			errorMessage.includes('Loading chunk') ||
			errorMessage.includes('preload') ||
			errorMessage.includes('vite')
		) {
			console.log(
				'Deployment error caught in componentDidCatch, ignoring:',
				errorMessage
			)
			return
		}

		this.props.onError?.(error, info)
		console.error('ErrorBoundary caught an error:', error, info)
		if (this.state.retryCount < MAX_TRIES) {
			this.setState(
				previousState => ({
					retryCount: previousState.retryCount + 1,
					error: null
				}),
				() => {
					// this.onReset()
				}
			)
		}
	}

	onReset(): void {
		this.props.onReset?.()
		this.setState(initialState)
		globalThis.location.href = globalThis.location.origin
	}

	render(): JSX.Element {
		const { error } = this.state

		if (error !== null) {
			const contextValue = { error, onReset: this.onReset }

			return (
				<ErrorBoundaryContext.Provider value={contextValue}>
					<ErrorFallback
						error={error.message}
						resetErrorBoundary={this.onReset}
					/>
				</ErrorBoundaryContext.Provider>
			)
		}

		return <>{this.props.children}</>
	}
}
